import(/* webpackMode: "eager" */ "/opt/calcom/apps/web/app/global-error.tsx");
